import { ReactNode, useRef } from 'react'

// ポップアップの末尾に置く要素は、中のトグルの状態が変わるたびに新しい要素になる。
// そのまま useMemo の依存に使うと、包んでいる Paper の識別子まで毎回変わってリストが
// 再マウントされ、スクロール位置が先頭に戻る。識別には有無だけを使い、中身はrefから読む。
export const useStableFooter = (
  footer: ReactNode
): { footerRef: { current: ReactNode }; hasFooter: boolean } => {
  const footerRef = useRef<ReactNode>(footer)
  footerRef.current = footer
  return { footerRef, hasFooter: Boolean(footer) }
}
